import * as React from 'react'
import LineFireIcon from 'LuxKit/Icons/line/LineFireIcon'
import LineFlowerIcon from 'LuxKit/Icons/line/LineFlowerIcon'
import LineGiftIcon from 'LuxKit/Icons/line/LineGiftIcon'
import LineGlassIcon from 'LuxKit/Icons/line/LineGlassIcon'
import LineHeartIcon from 'LuxKit/Icons/line/LineHeartIcon'
import LineLightbulbIcon from 'LuxKit/Icons/line/LineLightbulbIcon'
import LineMoonIcon from 'LuxKit/Icons/line/LineMoonIcon'
import LineMusicIcon from 'LuxKit/Icons/line/LineMusicIcon'
import LineSnowFlakeIcon from 'LuxKit/Icons/line/LineSnowFlakeIcon'
import LineStarIcon from 'LuxKit/Icons/line/LineStarIcon'
import LineSunIcon from 'LuxKit/Icons/line/LineSunIcon'
import LineTicketIcon from 'LuxKit/Icons/line/LineTicketIcon'
import LineTreesIcon from 'LuxKit/Icons/line/LineTreesIcon'
import LineWaterIcon from 'LuxKit/Icons/line/LineWaterIcon'
import LineWineBeerIcon from 'LuxKit/Icons/line/LineWineBeerIcon'
import type { SvgIconProps } from 'LuxKit/SvgIcon'
import type { SearchCalendarEventIconName } from 'constants/searchCalendarEvents'
import { SEARCH_CALENDAR_EVENT_FALLBACK_ICON } from 'constants/searchCalendarEvents'

const ICONS: Record<SearchCalendarEventIconName, React.ComponentType<SvgIconProps>> = {
  line_flower: LineFlowerIcon,
  line_glass: LineGlassIcon,
  line_star: LineStarIcon,
  line_music: LineMusicIcon,
  line_fire: LineFireIcon,
  line_snow_flake: LineSnowFlakeIcon,
  line_sun: LineSunIcon,
  line_moon: LineMoonIcon,
  line_heart: LineHeartIcon,
  line_gift: LineGiftIcon,
  line_trees: LineTreesIcon,
  line_water: LineWaterIcon,
  line_lightbulb: LineLightbulbIcon,
  line_ticket: LineTicketIcon,
  line_wine_beer: LineWineBeerIcon,
}

interface Props {
  name: SearchCalendarEventIconName
  size?: SvgIconProps['size']
}

function CalendarEventOverlayIcon(props: Props) {
  const { name, size = 'XS' } = props
  // Icon names come from the events feed, so a name this build does not know
  // must not reach the render as an undefined component.
  const Icon = ICONS[name] ?? ICONS[SEARCH_CALENDAR_EVENT_FALLBACK_ICON]

  return <Icon size={size} aria-hidden />
}

export default CalendarEventOverlayIcon
